(() => {
  const sliders = document.querySelectorAll('[data-digi-community-slider]');

  if (!sliders.length) return;

  sliders.forEach((slider) => {
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (event) => {
      isDown = true;
      slider.classList.add('is-dragging');

      startX = event.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('is-dragging');
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('is-dragging');
    });

    slider.addEventListener('mousemove', (event) => {
      if (!isDown) return;

      event.preventDefault();

      const x = event.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.2;

      slider.scrollLeft = scrollLeft - walk;
    });
  });
})();
